<div class="skills-dashboard">
  <div class="skills-header">
    <h2>
      {{ 'Skills Development' | translate }}
      <span class="total"
        >{{ 'Total' | translate }}: {{ totalScore }}/{{ totalCount }}</span
      >
    </h2>
    <div class="latest-entry">
      {{ 'Latest Entry' | translate }} :
      {{ lastAssessmentDate | date: 'dd-MMMM-yyyy' }}
    </div>
  </div>

  <div class="skills-content">
    <div class="skills-line">
      <app-flip-overview-graph
        *ngIf="detailsAndScore"
        [clientId]="clientId"
        [detailsAndScore]="detailsAndScore"
      ></app-flip-overview-graph>
    </div>

    <div class="skills-bars">
      <app-flip-groups-graph
        *ngIf="detailsAndScore"
        [detailsAndScore]="detailsAndScore"
      ></app-flip-groups-graph>
      <app-flip-subscore-graph
        *ngIf="detailsAndScore"
        [detailsAndScore]="detailsAndScore"
      ></app-flip-subscore-graph>
    </div>
  </div>
</div>
